import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";

const LoadingSpinner = ({
  size = "lg",
  color = "#071D54",
  thickness = "4px",
  speed = "0.65s",
  emptyColor = "gray.200",
  py = 4,
  mt = 0,
}) => {
  return (
    <Flex justifyContent="center" py={py} mt={mt}>
      <Spinner
        size={size}
        color={color}
        thickness={thickness}
        speed={speed}
        emptyColor={emptyColor}
      />
    </Flex>
  );
};

export default LoadingSpinner;
